export default __webpack_public_path__ + "static/media/environments-preview_light.5e1c2c97.jpg";